export default __webpack_public_path__ + "static/media/phone.e028432a.png";